import React from "react";

/** Standard page hero — copy from backend via usePageCopy. */
const PageHeader = ({ eyebrow, title, subtitle, children, testId }) => (
    <div className="mb-6 sm:mb-8" data-testid={testId}>
        {eyebrow ? <span className="eyebrow">{eyebrow}</span> : null}
        {title ? <h1 className="font-display font-bold text-2xl sm:text-3xl md:text-4xl mt-2 sm:mt-3">{title}</h1> : null}
        {subtitle ? <p className="text-sm text-[#4a4a52] mt-1 max-w-2xl">{subtitle}</p> : null}
        {children}
    </div>
);

export default PageHeader;
